<template>
    <span class="pause-outline-icon">
        <svg
            width="14"
            height="14"
            viewBox="0 0 24 24"
            fill="none"
            :stroke="stroke"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect x="14" y="3" width="5" height="18" rx="1" />
            <rect x="5" y="3" width="5" height="18" rx="1" />
        </svg>
    </span>
</template>

<script>
export default {
    name: 'IconPauseOutline',
    props: {
        stroke: {
            type: String,
            default: 'currentColor',
        },
    },
};
</script>

<style scoped>
/* See IconPlayOutline.vue for why the wrapper needs to be a flex container
   itself: a plain <span> as a flex/grid item doesn't center its own
   inline-level svg content vertically. */
.pause-outline-icon {
    display: inline-flex;
    align-items: center;
}
</style>
